<template>
  <!-- Register Dialog -->
  <v-dialog
    v-model="single_time_dialog"
    :width="width"
    content-class="card pa-0 register-dialog "
    v-if="step < 5 && single_time_dialog"
  >
    <v-btn
      icon
      dark
      variant="text"
      class="dialog-close-btn"
      @click="$emit('close-dialog')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <component
      @close-dialog="$emit('close-dialog')"
      :is="currentStepComponent"
      :is_mobile="is_mobile"
      :registeractivity="registeractivity"
      :activity="activity"
      :page="page"
      :stepLabel="stepLabel"
      :locationActive="locationActive"
      :locationIndex="locationIndex"
      :changing="true"
      :enroll="enroll"
      :multiple="false"
      :locale="$i18n.locale"
      :firstStep="firstStep"
      @next-step="nextStep"
      @prev-step="prevStep"
      @update-data="updateData"
      @register="register"
    />
  </v-dialog>

  <!-- Confirmation Dialog -->
  <relocation-confirm-dialog
    v-else-if="confirm_dialog"
    v-model="confirm_dialog"
    :new_date="toAmsterdamMidnight(registeractivity.date.date).getTime() / 1000"
    :new_start="registeractivity.date.slot.start"
    :new_end="registeractivity.date.slot.end"
    @close-dialog="$emit('close-dialog'), (confirm_dialog = false)"
    :image="activity.image"
  />
</template>

<script>
import StepOne from "../registercomponents/StepOne.vue";
import StepThree from "../registercomponents/StepThree.vue";
import StepFour from "../registercomponents/StepFour.vue";
import RelocationConfirmDialog from "../relocation_confirm_dialog.vue";
import isMobile from "@/mixins/isMobile";
import { toAmsterdamMidnight } from "@/util/DateUtil";

export default {
  mixins: [isMobile],
  components: {
    StepOne,
    StepThree,
    StepFour,
    RelocationConfirmDialog,
  },
  props: {
    activity: Object,
    page: Object,
    enroll: Object, // Keeps enroll functionality
  },
  data() {
    return {
      single_time_dialog: true,
      confirm_dialog: false,
      step: 1,
      registeractivity: {
        location: this.enroll.location,
        specialist: this.enroll.activity_specialist,
        enroll_id: this.enroll.enroll_id,
        dates: [],
        date: {
          date: "",
          slot: {},
        },
        reminder: true,
      },
    };
  },
  computed: {
    firstStep() {
      return this.buildComponents()[0] == this.buildComponents()[this.step - 1];
    },
    width() {
      if (this.is_mobile) return "calc(100% - 32px)";

      const isStepThree = this.buildComponents()[this.step - 1] === StepThree;
      return isStepThree ? "1098px" : "640px";
    },


    locationIndex() {
      return this.activity.locations.findIndex(
        (loc) => loc.id === this.registeractivity.location
      );
    },
    locationActive() {
      const components = this.buildComponents();

      if (components.includes(StepOne)) {
        return true;
      } else {
        return false;
      }
    },
    currentStepComponent() {
      const components = this.buildComponents();
      return components[this.step - 1];
    },
    stepCount() {
      const components = this.buildComponents();
      return components.length >= this.step;
    },
    stepLabel() {
      const components = this.buildComponents();
      const totalSteps = components.length;
      return this.$i18n.locale === "nl"
        ? `Stap ${this.step}/${totalSteps}`
        : `Step ${this.step}/${totalSteps}`;
    },
  },
  methods: {
    // Uit @/util/DateUtil, zodat de template hem kan aanroepen: de gekozen dag
    // is een lokale middernacht, de bevestiging leest een Amsterdamse epoch.
    toAmsterdamMidnight,
    buildComponents() {
      const components = [];

      const validLocations = this.activity.locations.filter((location) =>
        location.specialists.some((specialist) =>
          specialist.dates.some((date) =>
            date.slots.some((slot) => slot.spots > 0)
          )
        )
      );

      if (validLocations.length === 1) {
        this.registeractivity.location = validLocations[0].id;
        // Skip StepOne
      } else {
        components.push(StepOne);
      }

      components.push(StepThree, StepFour);

      return components;
    },
    nextStep() {
      this.step += 1;
    },
    prevStep() {
      this.step -= 1;
    },
    updateData(data) {
      Object.assign(this.registeractivity, data);
    },
    register() {
      this.registeractivity.title = this.activity.content.nl.banner.title;
      if (!this.sent) {
        this.registeractivity.enroll_id = this.enroll.enroll_id;
        this.sent = true;
        this.registeractivity.date = this.registeractivity.dates[0];
        this.$emit("update-enroll", this.registeractivity);
        this.step = 5;
        this.confirm_dialog = true;
      }
    },
  },
};
</script>
